import { html } from 'lit';
const Favorite =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.362 3.22c.57-1.51 2.707-1.51 3.276 0l1.56 4.144a.25.25 0 0 0 .223.162l4.423.203c1.613.075 2.273 2.107 1.012 3.116l-3.459 2.764a.25.25 0 0 0-.085.262l1.173 4.27c.428 1.556-1.3 2.812-2.65 1.925l-3.698-2.435a.25.25 0 0 0-.274 0l-3.699 2.435c-1.348.887-3.077-.369-2.65-1.926l1.174-4.27a.25.25 0 0 0-.085-.26l-3.459-2.765c-1.261-1.009-.6-3.041 1.012-3.116l4.423-.203a.25.25 0 0 0 .223-.162zm1.872.53a.25.25 0 0 0-.468 0l-1.56 4.143a1.75 1.75 0 0 1-1.558 1.131l-4.423.204a.25.25 0 0 0-.144.445l3.458 2.765a1.75 1.75 0 0 1 .595 1.83l-1.173 4.27a.25.25 0 0 0 .378.275l3.699-2.435a1.75 1.75 0 0 1 1.924 0l3.698 2.435a.25.25 0 0 0 .379-.275l-1.173-4.27a1.75 1.75 0 0 1 .595-1.83l3.458-2.765a.25.25 0 0 0-.144-.445l-4.423-.204a1.75 1.75 0 0 1-1.558-1.131z" clip-rule="evenodd"/>
  </svg>
`;
export default Favorite;
